import React, { forwardRef } from "react";
import ClinicPrintFrame from "../../../../Components/GeneralComponents/ClinicPrintFrame.js";

const tableHeaderCell = {
  borderBottom: "2px solid #0b8eb0",
  textAlign: "left",
  padding: "8px 4px",
  fontSize: "4.7mm",
  fontWeight: "bold",
  color: "#0b8eb0",
  whiteSpace: "nowrap",
};

const tableBodyCell = {
  borderBottom: "1px solid #edf2f5",
  textAlign: "left",
  padding: "8px 4px",
  fontSize: "4.2mm",
  fontWeight: "bold",
  verticalAlign: "top",
};

const containerStyle = {
  fontWeight: "700",
  fontSize: "3.8mm",
};

const PrescriptionPrint = forwardRef(({ data }, ref) => {
  const drugs = data?.drugs || [];
  const extraMedicines = data?.extra_medicines || [];

  const leftNotes = [
    { label: "B.P", value: data?.bp || "" },
    { label: "P.R", value: data?.pr || "" },
    { label: "R.R", value: data?.rr || "" },
    { label: "T", value: "37 °C" },
  ];

  return (
    <div ref={ref} style={containerStyle}>
      <ClinicPrintFrame
        doctorName={data?.doctor_display}
        date={data?.date}
        patientName={data?.patient_display}
        patientAge={data?.patient_age_display}
        patientGender={data?.patient_gender_display}
        leftNotes={leftNotes}
        diagnosis={data?.diagnosis}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={tableHeaderCell}>#</th>
              <th style={tableHeaderCell}>Medicine</th>
              <th style={tableHeaderCell}>Category</th>
              <th style={tableHeaderCell}>Qty</th>
              <th style={tableHeaderCell}>Times/24h</th>
              <th style={tableHeaderCell}>Instructions</th>
              <th style={tableHeaderCell}>Notation</th>
            </tr>
          </thead>
          <tbody>
            {drugs.map((drug, index) => (
              <tr key={`drug-${index}`}>
                <td style={tableBodyCell}>{index + 1}</td>
                <td style={tableBodyCell}>{drug.stock_medicine_display}</td>
                <td style={tableBodyCell}>
                  {drug.stock_medicine_category_display}
                </td>
                <td style={tableBodyCell}>{drug.quantity}</td>
                <td style={tableBodyCell}>{drug.times_per_24 ?? "-"}</td>
                <td style={tableBodyCell}>{drug.is_before}</td>
                <td style={tableBodyCell}>{drug.notation || ""}</td>
              </tr>
            ))}
            {extraMedicines.map((drug, index) => (
              <tr key={`extra-${index}`} style={{ backgroundColor: "#f9fcfd" }}>
                <td style={tableBodyCell}>{drugs.length + 1 + index}</td>
                <td style={tableBodyCell}>{drug.title}</td>
                <td style={tableBodyCell}>__</td>
                <td style={tableBodyCell}>{drug.quantity}</td>
                <td style={tableBodyCell}>{drug.times_per_24 ?? "-"}</td>
                <td style={tableBodyCell}>{drug.is_before}</td>
                <td style={tableBodyCell}>{drug.notation || ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </ClinicPrintFrame>
    </div>
  );
});

export default PrescriptionPrint;
